const BASE_API = process.env.REACT_APP_ROUTE_API;
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
    listar: async () => {
        try {
          const req = await fetch(`${BASE_API}site/noticias`, {
            method: 'GET',
            headers: headers
          });
          const json = await req.json();
                json.data = json.data ?? [];
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return(error);
        }
      },
    obterPorUrl: async (url) => {
      try {
        const req = await fetch(`${BASE_API}site/noticia/${url}`, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
};